// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  ScoreCard,
  GameTypeTab,
  StatsGraph,
  AllGametypeTab
}                         from '../../../components';

import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import styles                 from './style';
import { Spinner } from 'react-activity';
import ReactTable from "react-table"; 
import moment from "moment";
import DatePicker from 'react-datepicker';
import Card from '../../../components/card/Card';
import styled from 'styled-components';
import SessionHealth from '../sessionHealth';
import BatchHealthInfo from '../batchHealthInfo';
import LeadsSummary from '../leadsSummary';
import device     from "current-device";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import CustomerDetails from '../customerDetails';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
const is_mobile = device.mobile;  
// import {isMobile} from 'react-device-detect';

const customContentStyle = {
  width: '98%',
  maxWidth: 'none',
};

class Dashboard extends PureComponent {  

  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      section:props.match.params.section,
      customer_data: [],
      customer_headers: [],
      revenue_data: [],
      revenue_headers: [],
      booking_data: [],
      booking_headers: [],
      source_booking_data:[],
      source_booking_headers:[],
      collection_data:[],
      collection_headers:[],
      active_cust: 1,
      date: moment(),
      source_date: moment(),
      customer: true,
      bookings: false,
      revenue: false,
      batch_health: false,
      session_health: false,
      program_date_changed: false,
      source_date_changed: false,
      collection:false,
      program: true,
      source: false,
      active_cust_count: 0,
      revenue_count: 0,
      booking_count: 0,
      collection_Stats:0,
      batches_count:0,
      lead_count:0,
      excel_data:[],
      future_revenue_modal: false,
      future_revenue_data: [],
      future_revenue_header: []
    };
    this.handleSelection = this.handleSelection.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleSourceDate = this.handleSourceDate.bind(this);
    this.onCustomerClick = this.onCustomerClick.bind(this);
    this.onRevenueClick = this.onRevenueClick.bind(this);
    this.onBookingClick = this.onBookingClick.bind(this);
    this.onBatchClick = this.onBatchClick.bind(this);
    this.onSessionClick = this.onSessionClick.bind(this);
    this.onCollectionClick = this.onCollectionClick.bind(this);
    this.locationChanged = this.locationChanged.bind(this);
    this.getCollectionStats = this.getCollectionStats.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerDashboard');
  }

  componentDidMount() {
    this.getStats()
    this.getCollectionStats()
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    // $('.avtive_customers').find("a").trigger("click");
    // $('.monthly_revenue').find("a").trigger("click");
    if(!this.state.section){
      this.setState({section:'ActiveCustomer'});
    }
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerDashboard');
  }


  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      // this.getCustomers()
      this.getRevenue()        
      this.getBookings() 
      this.getBookingsBySource()
      this.getCollection() 
      this.getStats()
      this.getCollectionStats()    
    })
  }

  getStats() {
    const url = `${getLocationOrigin()}/cm/get_dashboard_stats/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({active_cust_count:data.active_cust,revenue_count:data.revenue,booking_count:data.booking,batches_count:data.batches})
           // alert("fix");
       }).catch(error => error);
  }

  getCollectionStats() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=1110&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({collection_Stats:data.data,excel_data:data.excel_data})
           // alert("fix");
       }).catch(error => error);
  }

  getCustomers() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=7537&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({customer_data:data.data,customer_headers:data.headers})
           // alert("fix");
       }).catch(error => error);
  }

  getRevenue() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=710039&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({revenue_data:data.data,revenue_headers:data.headers,excel_data:data.excel_data})
           // alert("fix");
       }).catch(error => error);
  }

  getBookings() {
    const date = this.state.date.format('YYYY-MM-DD');
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=2461&venue_id=${this.state.venue}&date=${date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({booking_data:data.data,booking_headers:data.headers,program_date_changed:false,excel_data:data.excel_data})
           // alert("fix");
       }).catch(error => error);
  }

  getBookingsBySource() {
    const date = this.state.source_date.format('YYYY-MM-DD');
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=1453&venue_id=${this.state.venue}&date=${date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({source_booking_data:data.data,source_booking_headers:data.headers,source_date_changed:false,excel_data:data.excel_data})
           // alert("fix");
       }).catch(error => error);
  }

  getCollection() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=751339&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({collection_data:data.data,collection_headers:data.headers,excel_data:data.excel_data})
           // alert("fix");
       }).catch(error => error);
  }

  getFutureRevenue() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=1829&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({future_revenue_data:data.data,future_revenue_header:data.headers})
           // alert("fix");
       }).catch(error => error);
  }

  renderCustomers(){
    var venue = this.state.venue;
    var headers = []
    if(this.state.customer_headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.customer_headers.length; i++) {
        if(this.state.customer_headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.customer_headers[i]);
          tab_index.push(i);
        }
      }
    }
    if(this.state.customer_data.length == 0 && headers.length == 0){
      this.getCustomers()
    }
    
    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Active Customers</div> 
        <table className="table_plain">
          <tr> 
            {headers.map((head)=>
              <th style={{padding:'10px'}}>{head}</th>
            )
          }
          </tr>
          
            { this.state.customer_data && this.state.customer_data.length > 0 ?
              this.state.customer_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )
              :
              
              this.state.customer_headers.length > 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
              
            }
        </table>
      </div>
      )
  }

  openFutureRevenue(){
    this.setState({future_revenue_modal: true},()=>this.getFutureRevenue())
  }

  renderRevenue(){
    var venue = this.state.venue;
    var headers = []
    if(this.state.revenue_headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.revenue_headers.length; i++) {
        if(this.state.revenue_headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.revenue_headers[i]);
          tab_index.push(i);
        }
      }
    }

    var future_headers = []
    if(this.state.future_revenue_header.length > 0){
      var future_tab_index = []
      for (var i = 0; i < this.state.future_revenue_header.length; i++) {
        if(this.state.future_revenue_header[i].indexOf("_hidden") == -1){
          future_headers.push(this.state.future_revenue_header[i]);
          future_tab_index.push(i);
        }
      }
    }

    if(this.state.revenue_data.length == 0 && headers.length == 0){
      this.getRevenue()
    }

    const actions = [
      
      <FlatButton
        label="Close"
        primary={true}
        labelPosition="before"
        labelStyle={{fontWeight: 'bold'}}
        icon={<i className="fa fa-times" aria-hidden="true" style={{color: 'white'}}></i>}
        style={{backgroundColor: 'rgb(160 40 79)', color: 'white', borderRadius: '5px'}}
        onClick={()=>this.setState({future_revenue_modal: false})}
      />,
    ]


    return(
      <div>
        <div style={{float:'right', marginTop: '1%'}}>

            <button className = 'btn btn-info' style={{fontWeight: 'bold'}} onClick={()=>this.openFutureRevenue()}> 
              Future Revenue 
              <i className="fa fa-arrow-circle-o-right" aria-hidden="true" style={{marginLeft: '5px'}}></i>
            </button>

            <Dialog
              title="Future Revenue"
              actions={actions}
              modal={true}
              autoScrollBodyContent={true}
              contentStyle={customContentStyle}
              open={this.state.future_revenue_modal}
              onRequestClose={()=>this.setState({future_revenue_modal: false})}
            >
              <table className="table_plain">
                <tr> 
                  { future_headers.map((head)=>
                    <th style={{fontSize: '13'}}>{head}</th>
                  )
                }
                </tr>
                
                  { this.state.future_revenue_data && this.state.future_revenue_data.length > 0 ?
                    this.state.future_revenue_data.map((data)=>
                        <tr>
                          { data.map((each,key)=>
                            future_tab_index.includes(key) &&
                            <td style={{ fontSize: '14', color: key == 0 && 'green'}} dangerouslySetInnerHTML={{__html:each}}></td>
                            )
                          }
                        </tr>
                      )
                    :
                    
                    this.state.future_revenue_header.length > 0 ?
                    <div style={{height:500}}>
                      <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
                    </div>
                    :
                    <div style={{height:500}}>
                      <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
                    </div>
                    
                  }
              </table>
            </Dialog>

        </div>
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading left" style={{marginTop:'1%',marginBottom:'2%',borderRadius:'5px',boxShadow: '0px 0px 2px 0px',display:'flex',justifyContent: 'space-between'}}>
          <span style={{fontWeight: 'bold',fontSize:'18px'}}> Revenue This Month </span>
          <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button btn btn-primary"
                        table="table-to"
                        filename="Monthly Revenue"
                        sheet="Monthly Revenue"
                        buttonText="Download as XLS"/>
        </div> 
        <table className="table_plain">
          <tr> 
            { headers.map((head)=>
              <th style={{padding:'10px'}}>{head}</th>
            )
          }
          </tr>
          
            { this.state.revenue_data && this.state.revenue_data.length > 0 ?
              this.state.revenue_data.map((data)=>
                  <tr>
                    { data.map((each,key)=>
                      tab_index.includes(key) &&
                      <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                      )
                    }
                  </tr>
                )
              :
              
              this.state.revenue_headers.length > 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
              
            }
        </table>
      </div>
      <table id="table-to" style={{display:'none'}}>
        <tr> {headers.map((head)=><th>{head}</th>)}</tr>
          {this.state.excel_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td >{each}</td>
                    )
                  }
                </tr>
                )}
          
      </table>
      </div>
      )
  }
  renderCollection(){
    var venue = this.state.venue;
    var headers = []
    if(this.state.collection_headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.collection_headers.length; i++) {
        if(this.state.collection_headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.collection_headers[i]);
          tab_index.push(i);
        }
      }
    }

    if(this.state.collection_data.length == 0){
      this.getCollection()
    }
    console.log('collectiondata')
    console.log(this.state.excel_data)
    
    return(
      <div>
      <div style={{float:'right',marginBottom:'1%'}}>
      

        <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button btn btn-primary"
                    table="table-to"
                    filename="Collection Details"
                    sheet="Collection Details"
                    buttonText="Download as XLS"/>


      </div>
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={{marginTop:'1%',marginBottom:'2%',fontSize:'18px',textAlign:'center',borderRadius:'5px',boxShadow: '0px 0px 2px 0px'}}>Collections Details </div> 
        <table className="table_plain">
          <tr> 
            {headers.map((head)=>
              <th style={{padding:'10px'}}>{head}</th>
            )
          }
          </tr>
          
            { this.state.collection_data && this.state.collection_data.length > 0 ?
              this.state.collection_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )
              :
              
              this.state.collection_headers.length > 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
              
            }
        </table>
      </div>
      <table id="table-to" style={{display: 'none'}}>
        <tr> {headers.map((head)=><th>{head}</th>)}</tr>
          {this.state.collection_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )}
          
      </table>
      </div>
      )
  }

  renderBookings(){
    var venue = this.state.venue;
    var headers = []
    if(this.state.booking_headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.booking_headers.length; i++) {
        if(this.state.booking_headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.booking_headers[i]);
          tab_index.push(i);
        }
      }
    }

    if(this.state.booking_data.length == 0 && this.state.booking_headers.length == 0 || this.state.program_date_changed){
      this.getBookings()
    }

    console.log('renderBookings')
    console.log(this.state.excel_data)
    
    return(
      <div>
        <div style={{float:'right',marginBottom:is_mobile() && '2%',marginTop:is_mobile() && '2%'}}>
        
          <ReactHTMLTableToExcel
                      id="test-table-xls-button"
                      className="download-table-xls-button btn btn-primary"
                      table="table-to"
                      filename="Bookings By Program"
                      sheet="Bookings By Program"
                      buttonText="Download as XLS"/>
     
        </div>
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={{marginTop:'1%',marginBottom:'2%',fontSize:'18px',textAlign:'center',borderRadius:'5px',boxShadow: '0px 0px 2px 0px'}}>Bookings By Program</div>         
        <div style={{display:'flex',margin:'1%'}}>
          <div> Date - </div>
          <DatePicker selected={this.state.date} onChange={this.handleDate}/>
        </div>
        <table className="table_plain">
          <tr> 
            { headers.map((head)=>
              <th style={{padding:'10px'}}>{head}</th>
            )
          }
          </tr>
          
            { this.state.booking_data && this.state.booking_data.length > 0 ?
              this.state.booking_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )
              :
              
              this.state.booking_headers.length > 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
              
            }

        </table>
      </div>
      <table id="table-to" style={{display:'none'}}>
        <tr> {headers.map((head)=><th>{head}</th>)}</tr>
          {this.state.excel_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td >{each}</td>
                    )
                  }
                </tr>
                )}
      </table>
      </div>
      )
  }


  onTabClick(tabname){
    //TODO - commenting for now.
    this.props.history.push("/dashboard/" + tabname)
    this.setState({
      section: tabname,
    });
  }

  renderBookingsBySource(){
    var venue = this.state.venue;
    var headers = []
    if(this.state.source_booking_headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.source_booking_headers.length; i++) {
        if(this.state.source_booking_headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.source_booking_headers[i]);
          tab_index.push(i);
        }
      }
    }
    if(this.state.source_booking_data.length == 0 && this.state.source_booking_headers.length == 0 || this.state.source_date_changed){
      this.getBookingsBySource()
    }

    console.log('renderBookingsBySource')
    console.log(this.state.excel_data)
    
    return(
      <div>
        <div style={{float:'right',marginBottom:is_mobile() && '2%',marginTop:is_mobile() && '2%'}}>
        
          <ReactHTMLTableToExcel
                      id="test-table-xls-button"
                      className="download-table-xls-button btn btn-primary"
                      table="table-to"
                      filename="Bookings By Source"
                      sheet="Bookings By Source"
                      buttonText="Download as XLS"/>
    
        </div>
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={{marginTop:'1%',marginBottom:'2%',fontSize:'18px',textAlign:'center',borderRadius:'5px',boxShadow: '0px 0px 2px 0px'}}>Bookings By Source</div> 
        <div style={{display:'flex',margin:'1%'}}>
          <div> Date - </div>
          <DatePicker selected={this.state.source_date} onChange={this.handleSourceDate}/>
        </div>
        <table className="table_plain">
          <tr> 
            {this.state.source_booking_headers.map((head)=>
              <th style={{padding:'10px'}}>{head}</th>
            )
          }
          </tr>
          
            { this.state.source_booking_data && this.state.source_booking_data.length > 0 ?
              this.state.source_booking_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td style={{textAlign:'left'}} dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )
              :
              
              this.state.source_booking_headers.length > 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
              
            }

        </table>
      </div>
      <table id="table-to" style={{display:'none'}}>
        <tr> {headers.map((head)=><th>{head}</th>)}</tr>
          {this.state.excel_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    tab_index.includes(key) &&
                    <td >{each}</td>
                    )
                  }
                </tr>
                )}
      </table>
      </div>
      )
  }

  handleSelection(event){
    const name = event.target.name;
    if(name == 'program'){
      this.setState({program:true,source:false})
    }
    else if(name == 'source'){
      this.setState({source:true,program:false})
    }
  }

  onCustomerClick(){
    this.setState({customer:true,bookings:false,revenue:false,batch_health:false,session_health:false,collection:false})
  }

  onRevenueClick(){
    this.setState({revenue:true,bookings:false,customer:false,batch_health:false,session_health:false,collection:false})
  }

  onBookingClick(){
    this.setState({bookings:true,revenue:false,customer:false,batch_health:false,session_health:false,collection:false})
  }

  onBatchClick(){
    this.setState({batch_health:true,bookings:false,customer:false,revenue:false,session_health:false,collection:false})
  }

  onSessionClick(){
    this.setState({session_health:true,bookings:false,customer:false,batch_health:false,revenue:false,collection:false})
  }
  onCollectionClick(){
    this.setState({collection:true,session_health:false,bookings:false,customer:false,batch_health:false,revenue:false})
  }

  handleDate(date){
    this.setState({date:date,program_date_changed:true},()=>{this.renderBookings();});
  }

  handleSourceDate(date){
    this.setState({source_date:date,source_date_changed:true},()=>{this.renderBookingsBySource();});
    
  }


  numberWithCommas(x) {
    // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return x.toLocaleString('en-IN');
  }
  

  render() {
    //console.log('Dashboard props',this.props)

    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }

    //console.log('customer_data',this.state.customer_data)
    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    const cust_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'
    const book_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'
    const rev_style = this.state.active_cust > 0 ? 'red' : '#4daa0b'

    const StyledRoot = styled.div`
      padding: 0px;
      display: flex;
      flex-direction: row;
      margin-Bottom:5px;
      `
    const StyledContainer = styled.div`
      width: 100%;
      padding:4px;
      
      `
    console.log(this.state)

    return(
      <div >
        <div className="breadcrumps" style={{'paddingLeft': "1%",'marginBottom':"1%"}}>
                        <a  onClick={() =>{this.onTabClick('ActiveCustomer')}} >
                          <span>Dashboard</span>
                        </a> 
                        {this.state.section == 'ActiveCustomer'  &&
                        <a  >
                          <span>Active Customer</span>
                        </a> }
                        {this.state.section == 'RevenueDetails'  &&
                        <a  >
                          <span>Revenue Details</span>
                        </a> }
                        {this.state.section == 'CollectionDetails'  &&
                        <a  >
                          <span>Collection Details</span>
                        </a> }
                        {this.state.section == 'BookingDetails'  &&
                        <a  >
                          <span>Booking Details</span>
                        </a> }
                        {this.state.section == 'BatchHealth'  &&
                        <a  >
                          <span>Batch Health</span>
                        </a> }
                        {this.state.section == 'SessionHealth'  &&
                        <a  >
                          <span>Session Health</span>
                        </a> }
                        {this.state.section == 'LeadsSummary' &&
                        <a>
                          <span>Leads Summary</span>
                        </a>}
          </div>
        <div >
          <StyledRoot className="col-md-12">
              <StyledContainer >
                <Card
                  title="Customers"
                  count={this.state.active_cust_count > 0 ? this.numberWithCommas(this.state.active_cust_count) : '-'}
                  action={"Contact"}
                  style={'#4daa0b'}
                  clicked= {this.state.section == 'ActiveCustomer'}
                  onClick={() =>{this.onTabClick('ActiveCustomer')}}
                />
              </StyledContainer>

              <StyledContainer >
                <Card
                  title="Leads Summary"
                  count={this.state.lead_count > 0 ? this.numberWithCommas(this.state.lead_count) : '-'}
                  action={"Contact"}
                  style={'#4daa0b'}
                  clicked= {this.state.section == 'LeadsSummary'}
                  onClick={() =>{this.onTabClick('LeadsSummary')}}
                />
              </StyledContainer>

              <StyledContainer >
                <Card
                  title="Revenue Details"
                  count={this.state.revenue_count > 0 ? this.numberWithCommas(this.state.revenue_count) : '-'}
                  action={"Contact"}
                  style={'#4daa0b'}
                  clicked= {this.state.section == 'RevenueDetails'}
                  onClick={() =>{this.onTabClick('RevenueDetails')}}
                />
              </StyledContainer>

              <StyledContainer >
                <Card
                  title="Collection Details"
                  action={"Contact"}
                  count ={this.state.collection_Stats > 0 ? this.numberWithCommas(this.state.collection_Stats) :'-'}
                  style={'#4daa0b'}
                  clicked= {this.state.section == 'CollectionDetails'}
                  onClick={() =>{this.onTabClick('CollectionDetails')}}
                />
              </StyledContainer>

          <StyledContainer >
            <Card
              title="Booking Details"
              count={this.state.booking_count > 0 ? this.numberWithCommas(this.state.booking_count) : '-'}
              action={"Contact"}
              style={'#4daa0b'}
              clicked= {this.state.section == 'BookingDetails'}
              onClick={() =>{this.onTabClick('BookingDetails')}}
            />
          </StyledContainer>
  
          <StyledContainer >
            <Card
              title="Batch Health"
              action={"Contact"}
              count ={this.state.batches_count > 0 ? this.numberWithCommas(this.state.batches_count) :'-'}
              style={'#4daa0b'}
              clicked= {this.state.section == 'BatchHealth'}
              onClick={() =>{this.onTabClick('BatchHealth')}}
            />
          </StyledContainer>
          
        </StyledRoot>
        
        </div>

        <div className='col-md-12'>
          {this.state.section == 'ActiveCustomer'  &&
            <CustomerDetails/>
          }

          {
            this.state.section == 'RevenueDetails' &&
            this.renderRevenue()
          }

          {

            this.state.section == 'BookingDetails' &&
            <div style={{marginTop:'1%'}}>
              {/*<button className='button1' style={{marginRight:'1%'}} name='program' onClick={this.handleSelection}> Bookings by Program </button>
              <button className='button1' style={{marginRight:'1%'}} name='source' onClick={this.handleSelection}> Bookings by Source </button>*/}              
              <div className='col-md-3 col-xs-6'> 
                <Tabs onClick = {()=>this.setState({program:true,source:false})} style={{color:this.state.program && 'white',backgroundColor:this.state.program && 'green'}}> Bookings by Program </Tabs>
              </div>
              <div className='col-md-3 col-xs-6'>
               <Tabs onClick = {()=>this.setState({source:true,program:false})} style={{color:this.state.source && 'white',backgroundColor:this.state.source && 'green'}}> Bookings by Source </Tabs>
              </div>
              {this.state.program &&
                this.renderBookings()
              }

              {this.state.source &&
                this.renderBookingsBySource()
              }
            </div>
          }

          {
            this.state.section == 'BatchHealth' &&
            <BatchHealthInfo/>
          }  

          {
            this.state.section == 'LeadsSummary' &&
            <LeadsSummary/>
          }         

         
          {this.state.section == 'CollectionDetails' && 
            this.renderCollection()
          }
        </div>  

      </div>
    );
  }
}

export default Dashboard;

const Tabs = styled.div`
  color: black ;
  background-color:beige;
  transition:0.5s;
  border: 2px solid green;
  padding: 7px;
  font-weight: 700;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
`




// WEBPACK FOOTER //
// ./src/app/views/centerportal/dashboard/Dashboard.js